import { DateInput, Edit, ImageField, ImageInput, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { Grid, Typography, Box } from '@mui/material';

const CourseEdit = () => {
	return (
		<Edit transform={(data: any) => ({ ...data, expert: data.expert._id })}>
			<SimpleForm>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">פרטי הקורס</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.he" label="כותרת בעברית" fullWidth />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.en" label="כותרת באנגלית" fullWidth />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="description.he" label="תיאור בעברית" fullWidth  multiline rows={8} />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="description.en" label="תיאור באנגלית" fullWidth  multiline rows={8}/>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">לוח זמנים</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<DateInput source="startDate" label="תאריך התחלה" fullWidth />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">מדריך</Typography>
					</Grid>
					
							<Box sx={{ mt: 2 }}>
								<ImageField source="image" sx={{ 
									'& image': { 
										maxWidth: '100%', 
										maxHeight: 200, 
										objectFit: 'contain' 
									} 
								}} />
							</Box>

					<Grid item sm={12}>
						<ImageInput source="image" label="תמונת הקורס" accept="image/*">
							
						</ImageInput>
					</Grid>
					<Grid item xs={12} sm={6}>
						<ReferenceInput reference="instructor/all" source="expert._id" filter={{ lnd: true }} perPage={999}>
							<SelectInput optionText={'name'} optionValue="_id" fullWidth />
						</ReferenceInput>
					</Grid>
				</Grid>
			</SimpleForm>
		</Edit>
	);
};
export default CourseEdit;
